import React, { Component } from 'react';
import TableData from '../component/TableData.js';
import TableHead from '../component/TableHead.js';
import axios from 'axios';
import {path} from './routes.js';

export default class ViewThankyous extends Component{
	constructor(props){
		super(props);
		this.state = {info:[]};
		this.getThankyous = this.getThankyous.bind(this);
	}

	getThankyous(){ //method for retrieving thank yous from DB
		let action;
		let name;
		let userID;
		if(this.props.view === "Sent"){ //parameters if user wants to view sent thank yous
			action = "sent";
			name = null;
			userID = this.props.userInfo.userID;
		}else if (this.props.view === "Received"){ //parameters if user wants to view received thank yous
			action = "received";
			name = this.props.userInfo.name;
			userID = null;
		}
		axios({ //retrieve thank yous
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data: {"endpoint":"info","table":"thankyous","action":action,"userID":userID,"name":name}
		}).then((response)=>{
			let data = response.data.data;
			this.setState({info:data});
		});
	}

	componentDidMount(){
		this.getThankyous();
	}

	componentDidUpdate(prevProps){ //if the view changes or the user creates a thank you, retrieve updated information
		if(prevProps.view !== this.props.view){
			this.getThankyous();
		}
		if(prevProps.submitted !== this.props.submitted){
			this.getThankyous();
		}
	}

	render(){
		let content;
		let objkeys = ["From","Reason","Value","Date"];
		if(this.props.view === "Sent"){
			objkeys[0] = "To";
			objkeys.push("Status");
		}
		const info = this.state.info;
		const colData = info.map((info,i) => { //each thankyou is mapped out as a table row
			return(
				<TableData key={i} columns={info} cellstyle="ba b--light-silver tc pa2" rowstyle="stripe-blue"/>
		)});
		if(this.props.active){
			if(this.state.info.length > 0){
				content = <div style={{margin:'auto',boxShadow: '3px 3px 5px 3px #888888',maxHeight:'560px',overflowY:'auto',overflowX:'auto'}} className="br3 fl w-100">
										<table className="fl w-100 collapse br3 bg-white overflow-x-hidden" style={{margin:'auto'}}>
											<thead className="collapse">
												<TableHead columns={objkeys} headstyle="pa2"/>
											</thead>
											<tbody className="br--bottom br3">
												{colData}
											</tbody>
										</table>
									</div>;
			}else{
				if(this.props.view === "Sent"){
					content = <div className="fl w-100 f3 tc" style={{margin:'auto'}}><p>You have currently sent 0 thank yous this year.</p></div>;
				}else{
					content = <div className="fl w-100 f3 tc" style={{margin:'auto'}}><p>You have currently received 0 thank yous this year.</p></div>;
				}
			}
		}
		return(
			<div>
			{content}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ViewThankyous.js